module.exports = __webpack_public_path__ + "img/a24.940ea74c.svg";